<template>
  <v-card min-height="550">
    <v-toolbar flat width="100%">
      <v-toolbar-title class="text-capitalize title"
        >{{ $t("animal.healthRecordInfo.disease") }}
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        @click="showAddDiseaseModal('edit')"
        v-if="animalDiseases && animalDiseases.length > 0"
        outlined
        right
        height="50"
        width="241"
        color="primary"
      >
        {{ $t("editCurrentRecord") }}
      </v-btn>
      <v-btn
        @click="showAddDiseaseModal('add')"
        right
        class="ml-5"
        height="50"
        width="241"
        color="primary"
        type="submit"
      >
        {{ $t("addNewRecord") }}
      </v-btn>
      <AddEditDisease
        @diseaseResult:success="onDiseaseResultSaved"
        v-if="showAddDisease"
        :dialogI="showAddDisease"
        :diseaseitem="diseaseItem"
        @closeAddDept="showAddDisease = false"
      />
    </v-toolbar>

    <v-row width="100%" class="mt-2">
      <v-col cols="12" md="4">
        <v-card class="pa-2 green2 elevation-0">
          <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
          <v-list class="green2">
            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-subtitle
                  >{{ $t("animal.healthRecordInfo.clinicalSymptoms") }}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span>
                      Observable e.g. diarrhea, limping, bloody discharge,
                      salivation, blindness, abortions
                    </span>
                  </v-tooltip>
                </v-list-item-subtitle>
                <v-list-item-title class="text-h6 mt-2">
                  <div class="text-h6 font-weight-bolder">
                    {{
                      currentDisease && currentDisease.clinicalSymptoms
                        ? currentDisease.clinicalSymptoms
                        : "Not Specified"
                    }}
                  </div>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-list-item-subtitle
            class="mt-n6 mb-n2 text-overline font-weight-light text-end text--secondary"
            >.</v-list-item-subtitle
          >
        </v-card>
      </v-col>

      <v-col cols="12" md="4">
        <v-card class="pa-2 green2 elevation-0">
          <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
          <v-list class="green2">
            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-subtitle
                  >{{ $t("animal.healthRecordInfo.tentativeDiagnosis") }}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span>
                      A tentative diagnosis is a diagnosis that can neither be
                      confirmed or a conclusion can be made. While they may
                      suspect, and have good background history to support it,
                      it's not a confirmed diagnosis until all the results are
                      in. No doctor is going to give you a diagnosis when they
                      need more information (most of the time blood tests or
                      body scans). It will be a tentative diagnosis until then.
                    </span>
                  </v-tooltip>
                </v-list-item-subtitle>
                <v-list-item-title class="text-h6 mt-2">
                  <div class="text-h6 font-weight-bolder">
                    {{
                      currentDisease && currentDisease.tentativeDiagnosis
                        ? currentDisease.tentativeDiagnosis
                        : "Not Specified"
                    }}
                  </div>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-list-item-subtitle
            class="mt-n6 mb-n2 text-overline font-weight-light text-end text--secondary"
            >.</v-list-item-subtitle
          >
        </v-card>
      </v-col>

      <v-col cols="12" md="4">
        <v-card class="pa-2 green2 elevation-0">
          <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
          <v-list class="green2">
            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-subtitle
                  >{{ $t("animal.healthRecordInfo.sampleCollected") }}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span>
                      Sample collected to make definite diagnosis e.g. blood,
                      urine, skin scrap, milk
                    </span>
                  </v-tooltip>
                </v-list-item-subtitle>
                <v-list-item-title class="text-h6 mt-2">
                  <div class="text-h6 font-weight-bolder">
                    {{
                      currentDisease && currentDisease.sampleCollected
                        ? currentDisease.sampleCollected
                        : "Not Specified"
                    }}
                  </div>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-list-item-subtitle
            class="mt-n6 mb-n2 text-overline font-weight-light text-end text--secondary"
            >.</v-list-item-subtitle
          >
        </v-card>
      </v-col>

      <v-col cols="12" md="4">
        <v-card class="pa-2 green2 elevation-0">
          <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
          <v-list class="green2">
            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-subtitle
                  >{{ $t("animal.healthRecordInfo.observationDate") }}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span>{{
                      $t("animal.healthRecordInfo.observationDate")
                    }}</span>
                  </v-tooltip>
                </v-list-item-subtitle>
                <v-list-item-title class="text-h6 mt-2">
                  <div class="text-h6 font-weight-bolder">
                    {{
                      currentDisease && currentDisease.diseaseDate
                        ? formatDate(currentDisease.diseaseDate)
                        : "Not Specified"
                    }}
                  </div>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-list-item-subtitle
            class="mt-n6 mb-n2 text-overline font-weight-light text-end text--secondary"
            >.</v-list-item-subtitle
          >
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card class="pa-2 green2 elevation-0">
          <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
          <v-list class="green2">
            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-subtitle
                  >{{ $t("animal.healthRecordInfo.nameOfVeterinarianNew") }}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span>{{
                      $t("animal.healthRecordInfo.veterinarianTechnicianNameTooltip")
                    }}</span>
                  </v-tooltip>
                </v-list-item-subtitle>
                <v-list-item-title class="text-h6 mt-2">
                  <div class="text-h6 font-weight-bolder">
                    {{
                      currentDisease && currentDisease.veterinarianName
                        ? currentDisease.veterinarianName
                        : "Not Specified"
                    }}
                  </div>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-list-item-subtitle
            class="mt-n6 mb-n2 text-overline font-weight-light text-end text--secondary"
            >.</v-list-item-subtitle
          >
        </v-card>
      </v-col>
    </v-row>

    <div class="mt-7 d-flex justify-space-between align-center">
      <span style="font-size: 20px">{{
        $t("animal.healthRecordInfo.diseaseHistory")
      }}</span>
    </div>
    <div>
      <!-- :items-per-page="20" -->
      <v-data-table
        class="mt-7"
        :headers="headersDisease"
        :items="showItems"
        hide-default-footer
        :loading="loadingDisease"
        show-select
        loading-text="Loading Data..."
        disable-pagination
      >
        <template v-slot:item.action="{ item }">
          <v-toolbar flat width="100%" color="transparent">
            <v-icon dark color="gray" @click="startDelete(item, 'edit')">
              mdi-pencil
            </v-icon>
            <v-icon dark color="red" @click="startDelete(item, 'delete')">
              mdi-delete
            </v-icon>
          </v-toolbar>
        </template>
        <template v-slot:item.diseaseDate="{ item }">
          {{ formatDate(item.diseaseDate) }}
        </template>
        <template v-slot:footer></template>
      </v-data-table>
    </div>

    <div class="mt-7 d-flex justify-space-between align-center">
      <span style="font-size: 20px">{{
        $t("animal.healthRecordInfo.labratoryResults")
      }}</span>
      <v-btn
        depressed
        color="primary"
        large
        class="font-weight-bold"
        @click="showAddLaboratoryModal"
      >
        <v-icon left> mdi-plus </v-icon>
        Add
      </v-btn>
    </div>

    <div>
      <!-- :items-per-page="20" -->
      <v-data-table
        class="mt-7"
        :headers="headers"
        :items="laboratoryResults"
        hide-default-footer
        :loading="loading"
        loading-text="Loading Data..."
        disable-pagination
      >
        <template v-slot:item.reports="{ item }">
          <div v-if="item.reportUrl != 'No File Chosen'" >
            <a class="text-decoration-underline black--text">{{
              item.reports
            }}</a>

            <a
              :href="item.reportUrl"
              target="_blank"
              class="text-decoration-underline black--text"
              >{{ $t("animal.healthRecordInfo.viewReport") }}</a
            >
            <v-btn class="ml-5" outlined small fab color="green">
              <v-icon color="green" @click="downloadPdf(item.reportUrl)">
                mdi-download-outline
              </v-icon>
            </v-btn>
          </div>
        </template>
        <template v-slot:item.action="{ item }">
          <v-toolbar flat width="100%" color="transparent">
            <v-icon dark color="gray" @click="laboratoryActions(item, 'edit')">
              mdi-pencil
            </v-icon>
            <v-icon dark color="red" @click="laboratoryActions(item, 'delete')">
              mdi-delete
            </v-icon>
          </v-toolbar>
        </template>
        <template v-slot:item.dateUploaded="{ item }">
          {{ formatDate(item.dateUploaded) }}
        </template>
        <template v-slot:footer></template>
      </v-data-table>
      <AddEditLaboratory
        @labResult:added="onLabResultAdded"
        v-if="showAddLaboratory"
        :dialogI="showAddLaboratory"
        :laboratoryItem="laboratoryItem"
        @closeAddDept="showAddLaboratory = false"
      />
    </div>

    <v-dialog
      v-model="showDeleteConfirm"
      transition="dialog-top-transition"
      max-width="500"
      persistent
    >
      <template>
        <v-card rounded="0">
          <v-toolbar color="secondary" class="white--text">
            <v-toolbar-title class="font-weight-bold">
              Warning
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
              icon
              class="white--text"
              @click="
                showDeleteConfirm = false;
                deleteItem = null;
              "
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text
            class="gray--text py-10"
            style="font-size: 16px"
            v-if="editOrDelete == 'delete'"
          >
            <h2>Are you sure ?</h2>
            <p class="mt-4">Do you really want to delete this record ?</p>
            <p>This process cannot be undone.</p>
            <!--<p>Your previous records might get affected.</p>-->
          </v-card-text>
          <v-card-text
            class="gray--text py-10"
            style="font-size: 16px"
            v-if="editOrDelete == 'edit'"
          >
            <h2>Are you sure ?</h2>
            <p class="mt-4">Do you really want to edit this record ?</p>
            <p>Your previous records might get affected.</p>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions class="px-4 py-5 justify-center">
            <div>
              <v-spacer></v-spacer>
              <v-btn
                @click="
                  showDeleteConfirm = false;
                  deleteItem = null;
                "
                outlined
                class="mr-2 px-5"
                right
                height="44"
                depressed
                color="primary"
              >
                 {{ $t("cancel") }}
              </v-btn>
              <v-btn
                @click="deleteDisease"
                right
                height="44"
                color="error"
                class="px-5"
                v-if="editOrDelete == 'delete'"
              >
                Delete
              </v-btn>
              <v-btn
                @click="editDiseaseConfirm"
                right
                height="44"
                color="error"
                class="px-5"
                v-if="editOrDelete == 'edit'"
              >
                Edit
              </v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>
    
    <v-dialog
      v-model="showLabDeleteConfirm"
      transition="dialog-top-transition"
      max-width="500"
      persistent
    >
      <template>
        <v-card rounded="0">
          <v-toolbar color="secondary" class="white--text">
            <v-toolbar-title class="font-weight-bold">
              Warning
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
              icon
              class="white--text"
              @click="
                showLabDeleteConfirm = false;
                deleteItem = null;
              "
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text
            class="gray--text py-10"
            style="font-size: 16px"
            v-if="editOrDelete == 'delete'"
          >
            <h2>Are you sure ?</h2>
            <p class="mt-4">Do you really want to delete this record ?</p>
            <p>This process cannot be undone.</p>
            <!--<p>Your previous records might get affected.</p>-->
          </v-card-text>
          <v-card-text
            class="gray--text py-10"
            style="font-size: 16px"
            v-if="editOrDelete == 'edit'"
          >
            <h2>Are you sure ?</h2>
            <p class="mt-4">Do you really want to edit this record ?</p>
            <p>Your previous records might get affected.</p>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions class="px-4 py-5 justify-center">
            <div>
              <v-spacer></v-spacer>
              <v-btn
                @click="
                  showLabDeleteConfirm = false;
                  deleteItem = null;
                "
                outlined
                class="mr-2 px-5"
                right
                height="44"
                depressed
                color="primary"
              >
                 {{ $t("cancel") }}
              </v-btn>
              <v-btn
                @click="deleteLabResult"
                right
                height="44"
                color="error"
                class="px-5"
              >
                Delete
              </v-btn>
          
            </div>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>
  </v-card>
</template>
<script>
import AddEditLaboratory from "./AddEditLaborotary.vue";
import AddEditDisease from "./AddEditDisease.vue";
import generalMixin from "@/mixins/GeneralMixin";
import { laboratoryResults } from "@/graphql/Health.gql";
import gql from "graphql-tag";
//import axios from 'axios';
export default {
  apollo: {
    laboratoryResults: {
      query: laboratoryResults,
      variables() {
        return {
          animalId: parseInt(this.$route.params.animal_number),
        };
      },
      update: (data) => data.labResHistories,
    },
    animalDiseases: {
      query: gql`
        query animalDiseasesByAnimal($animalId: Int!) {
          animalDiseasesByAnimal(animalId: $animalId) {
            id
            clinicalSymptoms: clinical_symptoms
            tentativeDiagnosis: tentative_diagnosis
            sampleCollected: sample_collected
            veterinarianName: veterinarian_name
            diseaseDate: disease_date
          }
        }
      `,
      variables() {
        return {
          animalId: parseInt(this.$route.params.animal_number),
        };
      },
      result: function ({ data }) {
        if (data) {
          //array1.shift();
          this.currentDisease = data.animalDiseasesByAnimal[0] || null;
        }
      },
      update: (data) => {
        return data.animalDiseasesByAnimal;
      },
      error: (err) =>
        this.$notify({
          title: "Error loading animal diseases!",
          text: err,
          type: "error",
          position: "top right",
        }),
    },
  },
  components: {
    AddEditLaboratory,
    AddEditDisease,
  },
  mixins: [generalMixin],
  computed: {
    showItems() {
      let showData = [...this.animalDiseases];
      showData.shift();
      return showData;
    },
  },
  data() {
    return {
      deleteItem: null,
      editOrDelete: "edit",
      diseaseItem: null,
      laboratoryItem:null,
      showDeleteConfirm: false,
      showLabDeleteConfirm:false,
      currentDisease: {},
      showAddLaboratory: false,
      loading: false,
      headers: [
        {
          text: "Date Uploaded",
          align: "start",
          sortable: true,
          value: "dateUploaded",
        },
        {
          text: "Laboratory Name",
          align: "start",
          sortable: true,
          value: "laboratoryName",
        },
        {
          text: "Laboratory Attendent",
          align: "start",
          sortable: true,
          value: "laboratoryAttended",
        },
        {
          text: "Notes",
          align: "start",
          sortable: true,
          value: "notes",
        },
        { text: "Reports", value: "reports" },
        {
          text: "",
          align: "start",
          sortable: false,
          value: "action",
        },
      ],

      showAddDisease: false,
      loadingDisease: false,
      headersDisease: [
        {
          text: "Clinical Symptoms/Signs",
          align: "start",
          sortable: true,
          value: "clinicalSymptoms",
          class: "text-no-wrap"
        },
        {
          text: "Tentative Diagnosis",
          align: "start",
          sortable: true,
          value: "tentativeDiagnosis",
          class: "text-no-wrap"
        },
        {
          text: "Sample Collected",
          align: "start",
          sortable: true,
          value: "sampleCollected",
          class: "text-no-wrap"
        },
        {
          text: "Observation Date",
          align: "start",
          sortable: true,
          value: "diseaseDate",
          class: "text-no-wrap"
        },
        {
          text: "Veterinarian/Technician Name",
          align: "start",
          sortable: true,
          value: "veterinarianName",
          class: "text-no-wrap"
        },
        {
          text: "",
          align: "start",
          sortable: false,
          value: "action",
        },
      ],
    };
  },
  methods: {
    downloadPdf(url) {
      console.log("sssss");
      let link = document.createElement("a");
      link.download = `${new Date().getTime()}_lab.pdf`;
      link.href = url;
      link.target = "_blank";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    // async forceFileDownload(response, title) {
    //   const url = window.URL.createObjectURL(new Blob([response.data]))
    //   const link = document.createElement('a')
    //   link.href = url
    //   link.setAttribute('download', title)
    //   document.body.appendChild(link)
    //   link.click()
    // },
    // downloadWithAxios(url, title) {

    //  axios({
    //     method: 'get',
    //     url,
    //     responseType: 'arraybuffer',
    //   })
    //     .then((response) => {
    //      this.forceFileDownload(response, title)
    //     })
    //     .catch((e) => console.log(e,'error occured'))
    // },

    formatDate(date) {
      if (!date) return "";
      let diseaseDate = new Date(date);
      diseaseDate =
        diseaseDate.getFullYear() +
        "-" +
        diseaseDate.getMonth() +
        "-" +
        diseaseDate.getDate();
      return diseaseDate;
    },
    async startDelete(item, action) {
      this.editOrDelete = action;

      if (action == "edit") {
        this.showAddDisease = true;
        this.diseaseItem = item;
      } else {
        this.showDeleteConfirm = true;
        this.deleteItem = item;
      }

      //this.$apollo.queries.birthOriginByFarmId.skip = false;
      //let res = await this.$apollo.queries.birthOriginByFarmId.refetch();
      //this.noOfAnimalsInFarm = res.data.birthOriginByFarmId
    },
    
    async laboratoryActions(item, action) {
      this.editOrDelete = action;

      if (action == "edit") {
        this.showAddLaboratory = true;
        this.laboratoryItem = item;
      } else {
        this.showLabDeleteConfirm = true;
        this.deleteItem = item;
      }

      //this.$apollo.queries.birthOriginByFarmId.skip = false;
      //let res = await this.$apollo.queries.birthOriginByFarmId.refetch();
      //this.noOfAnimalsInFarm = res.data.birthOriginByFarmId
    },
    onLabResultAdded() {
      this.showAddLaboratory = false;
      this.$apollo.queries.laboratoryResults.refetch();
    },
    showAddLaboratoryModal() {
      this.showAddLaboratory = true;
    },

    async onDiseaseResultSaved() {
      this.showAddDisease = false;
      await this.$apollo.queries.animalDiseases.refetch();
      this.currentDisease = await this.animalDiseases[0];
    },
    editDisease(item) {
      this.diseaseItem = item;
      this.showDeleteConfirm = true;
    },
    editDiseaseConfirm() {
      this.showAddDisease = true;
      this.showDeleteConfirm = false;
      this.editOrDelete = "edit";
    },
    showAddDiseaseModal(action) {
      if (action == "edit") {
        this.editOrDelete = "edit";
        this.diseaseItem = this.currentDisease;
        this.showAddDisease = true;
        //this.showDeleteConfirm = true;
      } else {
        this.diseaseItem = null;
        this.showAddDisease = true;
      }
    },
    
    async deleteDisease() {
      if (!this.deleteItem) {
        alert("No disease to delete");
        return;
      }

      let item = this.deleteItem;
      //this.startLoading();
      this.$apollo
        .mutate({
          // Query
          mutation: gql`
            mutation ($diseaseId: Int!) {
              removeAnimalDisease(diseaseId: $diseaseId) {
                success
              }
            }
          `,
          // Parameters
          variables: {
            diseaseId: Number(item.id),
          },
        })
        .then(async (response) => {
          this.$notify({
            title: `History deleted successfully`,
            text: response.message,
            type: "success",
            position: "top right",
          });

          this.showDeleteConfirm = false;
          this.deleteItem = null;
          this.$apollo.queries.animalDiseases.refetch();
          //this.stopLoading();
        })
        .catch(async (error) => {
          console.log(error);
          this.showDeleteConfirm = false;
          this.deleteItem = null;
          //this.stopLoading();
        });
      console.log("delete disease");
    },
    
    async deleteLabResult() {
      if (!this.deleteItem) {
        alert("No labresult to delete");
        return;
      }

      let item = this.deleteItem;
      //this.startLoading();
      this.$apollo
        .mutate({
          // Query
          mutation: gql`
            mutation ($labResultId: Int!) {
              removeLabResult(labResultId: $labResultId) {
                success
              }
            }
          `,
          // Parameters
          variables: {
            labResultId: Number(item.id),
          },
        })
        .then(async (response) => {
          this.$notify({
            title: `Lab Result deleted successfully`,
            text: response.message,
            type: "success",
            position: "top right",
          });

          this.showLabDeleteConfirm = false;
          this.deleteItem = null;
          this.$apollo.queries.laboratoryResults.refetch();
          //this.stopLoading();
        })
        .catch(async (error) => {
          console.log(error);
          this.showDeleteConfirm = false;
          this.deleteItem = null;
          //this.stopLoading();
        });
      console.log("delete disease");
    },
  },
};
</script>

<style scoped>
.v-list-item__title, .v-list-item__subtitle{
  white-space: initial;
}
</style>
